// DS: i3.9
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Upload: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M4 13.1a.9.9 0 100 1.8h8a.9.9 0 000-1.8H4z"></path>
        <path
          fillRule="evenodd"
          d="M5 12h6a1 1 0 001-1V8.4h1.6a1 1 0 00.666-1.746l-5.6-5a1 1 0 00-1.332 0l-5.6 5A1 1 0 002.4 8.4H4V11a1 1 0 001 1zm5-4.6V10H6V7.4a1 1 0 00-.978-1L8 3.74l2.98 2.66a1 1 0 00-.98 1z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
Upload.displayName = 'Upload';

export default Upload;
